export const getPrintTemplate = (values) => {
  const {
    unit = "",
    address = "",
    accountCode = "",
    year = "",
    openingDebit = 0,
    openingCredit = 0,
    details = [],
    debitOccurence = {},
    creditOccurence = {},
    closingDebit = {},
    closingCredit = {},
    signingDay = "",
    signingMonth = "",
    signingYear = "",
    ledgerClerk = "",
    chiefAccountant = "",
    legalRepresentative = "",
  } = values;

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "");

  const renderMonthCells = (mv) => {
    let cells = "";
    for (let i = 1; i <= 12; i++) {
      cells += `<td class="border text-right px-1">${fmt(mv[`month${i}`])}</td>`;
    }
    cells += `<td class="border text-right px-1 font-bold bg-light">${fmt(mv.total)}</td>`;
    return cells;
  };

  const detailRows = details.map((d) => `
    <tr>
      <td class="border px-1">${d.offsetAccount || ""}</td>
      ${renderMonthCells(d)}
    </tr>
  `).join("");

  return `
    <div style="font-family: 'Times New Roman', Times, serif; font-size: 12px; color: black; line-height: 1.4;">
      <table width="100%">
        <tr>
          <td width="50%" valign="top">
            <div class="font-bold">Đơn vị: <span class="dotted-line">${unit}</span></div>
            <div class="font-bold">Địa chỉ: <span class="dotted-line">${address}</span></div>
          </td>
          <td width="50%" align="center">
            <div class="font-bold">Mẫu số S05-DN</div>
            <div style="font-style: italic; font-size: 11px;">(Kèm theo Thông tư số 99/2025/TT-BTC <br/> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
          </td>
        </tr>
      </table>

      <div style="text-align: center; margin: 15px 0;">
        <h2 style="margin: 0; text-transform: uppercase; font-size: 16px;">SỔ CÁI</h2>
        <div style="font-style: italic; font-weight: bold;">(Dùng cho hình thức Nhật ký - Chứng từ)</div>
        <div style="margin-top: 5px;">
          Tài khoản: <span class="font-bold">${accountCode}</span> &nbsp;&nbsp;&nbsp; Năm: <span class="font-bold">${year}</span>
        </div>
      </div>

      <div style="margin-bottom: 15px;">
        <table style="border-collapse: collapse;">
          <tr>
            <td class="border px-1 font-bold" rowspan="2" width="100">Số dư đầu năm</td>
            <td class="border px-1 font-bold" width="60">Nợ</td>
            <td class="border text-right px-1" width="120">${fmt(openingDebit)}</td>
          </tr>
          <tr>
            <td class="border px-1 font-bold">Có</td>
            <td class="border text-right px-1">${fmt(openingCredit)}</td>
          </tr>
        </table>
      </div>

      <table width="100%" style="border-collapse: collapse; margin-top: 10px; table-layout: fixed;">
        <thead>
          <tr>
            <th class="border" width="120">Ghi Có các TK đối ứng Nợ với TK này</th>
            ${[...Array(12)].map((_, i) => `<th class="border" width="65">Tháng ${i + 1}</th>`).join("")}
            <th class="border" width="85">Cộng</th>
          </tr>
          <tr bgcolor="#F0F0F0">
            <th class="border">A</th>
            ${[...Array(13)].map((_, i) => `<th class="border">${i + 1}</th>`).join("")}
          </tr>
        </thead>
        <tbody>
          ${detailRows}
          
          <tr class="font-bold bg-light">
            <td class="border px-1">Cộng số phát sinh Nợ</td>
            ${renderMonthCells(debitOccurence)}
          </tr>
          
          <tr class="font-bold bg-light">
            <td class="border px-1">Tổng số phát sinh Có</td>
            ${renderMonthCells(creditOccurence)}
          </tr>
          
          <tr>
            <td class="border px-1 font-bold">Số dư cuối tháng (Nợ)</td>
            ${renderMonthCells(closingDebit)}
          </tr>
          
          <tr>
            <td class="border px-1 font-bold">Số dư cuối tháng (Có)</td>
            ${renderMonthCells(closingCredit)}
          </tr>
        </tbody>
      </table>

      <table width="100%" style="margin-top: 30px; text-align: center;">
        <tr>
          <td width="30%">
            <div class="font-bold">Người ghi sổ</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên)</div>
            <div style="margin-top: 50px;" class="font-bold">${ledgerClerk}</div>
          </td>
          <td width="30%">
            <div class="font-bold">Kế toán trưởng</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên)</div>
            <div style="margin-top: 50px;" class="font-bold">${chiefAccountant}</div>
          </td>
          <td width="40%">
            <div style="font-style: italic; font-size: 12px; margin-bottom: 5px;">Ngày ${signingDay} tháng ${signingMonth} năm ${signingYear}</div>
            <div class="font-bold">Người đại diện theo pháp luật</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên, đóng dấu)</div>
            <div style="margin-top: 50px;" class="font-bold">${legalRepresentative}</div>
          </td>
        </tr>
      </table>

      <style>
        .border { border: 1px solid black; }
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .font-bold { font-weight: bold; }
        .px-1 { padding: 4px; }
        .bg-light { background-color: #f9f9f9; }
        .dotted-line { border-bottom: 1px dotted black; }
        @media print {
            @page { size: A4 landscape; margin: 1cm; }
        }
      </style>
    </div>
  `;
};
